import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { CaseState } from '../_types/case-state';
import { CasesStatesService } from '../_services/cases-states.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { LoginService } from '../../login/login.service';
import { firstValueFrom } from 'rxjs';
import { ColorPicker } from 'primeng/colorpicker';
import { CasesModesService } from '../../cases/_services/cases-modes.service';
import { CaseStateCaseModeService } from '../_services/case-state-case-mode.service';

@Component({
    selector: 'app-cases-states-detail',
    templateUrl: './cases-states-detail.component.html',
    styleUrls: ['./cases-states-detail.component.scss'],
    standalone: false
})
export class CasesStatesDetailComponent {
  public caseStateFormGroup!: RxFormGroup;

  public caseState: CaseState = new CaseState();

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  public caseModes: any[] = [];
  public selectedCaseModeIds: string[] = [];

  constructor(
    private casesStatesService: CasesStatesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService,
    private casesModesService: CasesModesService,
    private caseStateCaseModeService: CaseStateCaseModeService,
  ) {

    this.caseStateFormGroup = this.formBuilder.formGroup<CaseState>(this.caseState) as RxFormGroup;
  }

  async ngOnInit() {
    this.topbarService.setTitle("Detalle de estado de expediente");
    this.topbarService.addBreadcrumb("Estados de expediente", "/casesStates");
    await this.loadCaseModes();
    let id = this.route.snapshot.params['id'];
    if (id != null && id != '0') {
      await this.loadCaseState(id);
    }
    this.allowWrite = true; //this.loginService.hasPermission("CASES_TYPES.WRITE");
    this.allowDelete = true; //this.loginService.hasPermission("CASES_TYPES.DELETE");

  }

  async loadCaseModes() {
    //sin sort, por decision expresa: cases_modes no tiene columna de orden, y ordenar por
    //nombre cambiaria el orden de los switches respecto al que hay hoy
    let response = await firstValueFrom(this.casesModesService.all());
    this.caseModes = response.data;
  }

  async loadCaseState(id: string) {
    this.caseState = await firstValueFrom(this.casesStatesService.get(id));
    this.caseStateFormGroup.patchValue(this.caseState);
    if (this.caseState.isSystem) {
      this.caseStateFormGroup.get('name')?.disable();
      this.caseStateFormGroup.get('isInitial')?.disable();
      this.caseStateFormGroup.get('isFinal')?.disable();
      this.caseStateFormGroup.get('notUpdateWhenCaseServiceConfirmed')?.disable();
    }
    this.selectedCaseModeIds = await this.caseStateCaseModeService.loadModeIdsFor(id);
  }


  async save() {
    let valid = this.formValidationService.validateForm(this.caseStateFormGroup);
    if (valid) {
      this.caseState = Object.assign(this.caseState, this.caseStateFormGroup.value);
      //primero el estado: su save limpia la cache del listado. Despues las relaciones, y solo
      //entonces navegar, para que el listado relea del servidor
      let caseState = await firstValueFrom(this.casesStatesService.save(this.caseState));
      await this.caseStateCaseModeService.replaceForCaseState(caseState.id!, this.selectedCaseModeIds);
      this.messageService.add({ closable: true, severity: 'success', summary: "Estado de expediente guardado correctamente." });
      this.router.navigate(['casesStates']);
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el estado de expediente?",
      header: "Eliminar estado de expediente",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.casesStatesService.delete(this.caseState.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Estado de expediente eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.router.navigate(['casesStates']);
  }

  public onColorChanged(color: ColorPicker): void {
    color.writeValue(color.inputBgColor);
    color.onModelChange(color.inputBgColor);
  }
}
